export default {
    sign_up: 'Inscrivez-vous',
    earn_points_desc: 'Gagnez des EcoCredits à chaque achat.',
    earn_points: 'GAGNEZ DES ECOCREDITS',
    redeem_points: 'ÉCHANGER DES ECOCREDITS',
    redeem_points_desc: 'Échangez vos EcoCrédits pour des réductions exclusives et des cadeaux.',
    sign_up_desc: 'Créez un compte et obtenez 500 EcoCredits.',
    copy_desc: "Vous avez copié le code, veuillez vous rendre en boutique pour l'utiliser.",
    see_t_c: 'Voir les conditions générales',
    join_subTitle: 'Inscrivez-vous maintenant et cumulez des points pour profiter de réductions et de cadeaux exclusifs.',
    send_your_friend: 'Envoyez {amont} de votre carte-cadeau à un ami.',
    purchase: 'Achat',
    coupon: 'Code de réduction',
    login_capital_letters: 'Se connecter',
    login_capital_letters1: 'Connectez-vous',
    received: 'Reçu',
    subscribe_capital_letters: "S'inscrire",
    birthday_placeholder: 'JJ/MM/AA',
    shop_capital_letters: 'Achetez',
    shop: 'Gagnez des points à chaque achat',
    ecoflow_benefits: 'Avantages des EcoCredits',
    complete_profile: 'Complétez le profil',
    referral: 'Invitez vos proches',
    referral_desc: "Gagnez des EcoCredits pour chaque ami qui s'inscrit avec succès.",
    referral_btn: 'Rejoignez-nous maintenant',
    warranty: 'Enregistrez votre produit EcoFlow',
    points_activity_a: 'Mon activité',
    points_tab_name: 'Historique des activités',
    rewards_tab_name: 'Historique des récompenses',
    coupon_used_desc: 'Servez-vous de ce code à la caisse pour échanger {amont} votre carte-cadeau.',
    email_address: 'Adresse e-mail',
    give_away: 'Jeu-concours',
    subscribe: 'Abonnez-vous à notre newsletter',
    profile: 'Complétez les informations de votre profil',
    status: 'Statut',
    refund: 'Remboursement',
    points_balance: 'Solde des EcoCredits',
    points_progress_tips: 'Nombre de points requis pour devenir {plus} : {points} EcoCredits',
    available: 'Disponible',
    sign_up_text: "500 EcoCredits à l'inscription",
    redeemed_succ: 'Échangées avec succès !',
    current_tier: 'Statut',
    subscribe_now: 'Abonnez-vous dès maintenant',
    date: 'Date',
    used: 'Utilisé',
    edeemed_rewards_note: 'Vos récompenses échangées apparaîtront ici.',
    warranty_capital_letters: 'Garantie',
    days_rules2: 'Valable à partir de {data}.',
    redeem_now: 'ÉCHANGER MAINTENANT',
    product_rules: 'Pour {product} seulement',
    membership_includes: 'ABONNEMENT INCLUT',
    browse_ecocredits_rewards: 'Consultez les récompenses EcoCredits',
    discount: 'Réduction',
    view_more: 'Afficher plus',
    profile_desc1: "Gagnez jusqu'à 1000 EcoCredits en complétant votre profil.",
    profile_desc2: "Obtenez jusqu'à 1000 EcoCredits en ajoutant vos coordonnées.",
    points_capital_letters: 'EcoCredits',
    history_note: 'Votre activité apparaîtra ici. Vous ne voyez pas encore votre activité ? Votre activité sera mise à jour dans les 24 heures.',
    lucky_flop_start: 'S’inscrire',
    lucky_flop_congrat: 'Félicitations',
    lucky_flop_get: 'Obtenir mes récompenses',
    lucky_flop_open: 'Retourner',
    rules: 'Règles',
    completed_text: 'Vous avez déjà obtenu cette récompense.',
    redeemed: 'Échangées',
    birthday: 'ANNIVERSAIRE',
    summary_text: 'Le résumé de vos EcoCredits',
    deducted: 'Déduit',
    site_rules: 'Réservé aux clients de la boutique française.',
    subscribe_hover: 'Gagnez 500 EcoCredits lors de votre inscription.',
    subscribe_text: 'Inscrivez-vous à la newsletter ÉcoFlow.',
    store: 'Acheter maintenant',
    membership: 'MEMBRE',
    join_now: "S'INSCRIRE",
    gift_card: 'Carte-cadeau',
    rewards_redeemed: 'Mes récompenses',
    redeedmed_tab_name: 'Échangé',
    issued_tab_name: 'Émis',
    expired: 'Arrivé à expiration',
    login: 'SE CONNECTER',
    earn_points_title: 'Comment gagner des points ?',
    have_points: 'Vous avez <code>{points} EcoCredits</code>',
    view_all: 'Voir tout',
    add_your_birthday: 'Ajoutez votre anniversaire',
    earn_point_rule_shop: 'Obtenez 1 EcoCredits pour chaque euro dépensé.',
    off: 'DE RÉDUCTION',
    earn_point_by_order: 'Gagnez à chaque commande.',
    registered: 'Inscrit',
    birthday_desc2: 'Gagnez {points} EcoCredits lorsque vous ajoutez votre date de naissance.',
    sign_up_desc_h: 'Créez un compte et obtenez 500 EcoCredits.',
    birthday_desc1: 'Ajoutez votre date de naissance pour obtenir des EcoCredits.',
    or_text: 'OU',
    profile_a: 'Profil',
    days_rules: "Valable pendant {days} jours à partir de la date d'échange",
    join_title: 'Rejoignez le programme de fidélité EcoFlow !',
    pending: 'En attente',
    coming_soon: 'À venir',
    shop_to_earn_points: 'Achetez pour gagner des EcoCredits',
    action: 'Action',
    rewards_title: 'Récompenses',
    question_title: 'Participez au quiz',
    type_title: 'Type',
    discount_type: 'Réduction',
    already_member: 'Êtes-vous déjà membre ?',
    already_member1: 'Vous possédez déjà un compte ?',
    points_activity: 'ACTIVITÉ DES ECOCREDITS',
    use_this_code_note: 'Servez-vous de ce code à la caisse pour échanger <PI1/> votre carte-cadeau.',
    warranty_desc2: '1000 EcoCredits lorsque vous enregistrez un produit.',
    warranty_desc1: "1000 EcoCredits pour l'enregistrement de votre produit",
    redeem_ecocredits_title: 'Échanger mes points',
    redeem_ecocredits_title_next: 'Transformez vos points en cadeaux et réductions exclusifs disponibles dès maintenant !',
    member_exclusive: '',
    redeem_ecocredits_subtitle_next: "Inscrivez-vous et économisez 50 % d'EcoCredits sur vos accessoires pour système solaire de balcon !",
    redeem_ecocredits_rules_title1: 'Présentation de l’événement:',
    redeem_ecocredits_rules_title2: 'Mécanisme d’événement:',
    redeem_ecocredits_rules_desc1:
        'Ne manquez pas nos offres éphémères d’échange d’EcoCredits contre des cadeaux du 20 au 23 octobre 2023. Des offres spéciales apparaîtront aléatoirement à ces dates !',
    redeem_ecocredits_rules_desc2:
        '1. Découvrez des surprises plus tôt. Abonnez-vous et soyez le premier à connaître les heures de début de ventes flash pour échanger vos récompenses EcoCredits.',
    redeem_ecocredits_rules_desc3:
        '2. Tirez le meilleur parti de vos EcoCredits. Pendant chaque vente flash, bénéficiez d’une réduction allant jusqu’à 50 % en échangeant vos points de récompense. Mais agissez vite ! Le stock de produits participants à la promotion est limitée. Chaque jour, quatre produits uniques seront mis en avant dans la promotion, chacun avec un maximum de 100 unités disponibles.',
    points: 'EcoCredits',
    benefits_link_btn: 'Parrainer',
    network_error: 'Erreur réseau',
    confirm_text: "Voulez-vous vraiment procéder à l'échange ? Vous ne pouvez pas annuler cette action.",
    manually_deducted: 'Déduction manuelle',
    redeeming_points: "ÉCHANGE D'ECOCREDITS",
    earning_points: "OBTENTION D'ECOCREDITS",
    confirm_btn: 'Confirmer',
    faq_title: 'Foire aux questions',
    no_enough_points: "Échec de l'échange, vos EcoCredits ne sont pas suffisants",
    no_history_note: 'Vous ne voyez pas encore vos EcoCredits ? Votre activité sera mise à jour dans les 24 heures.',
    no_coupon_note: 'Aucune récompense échangée pour le moment.',
    minimum_price: "Montant minimum d'achat ({price}).",
    minimum_num: "Quantité minimum d'articles ({num} articles).",
    stay_too_long: 'Votre session a expiré. Veuillez actualiser la page et réessayer.',
    order_rule: 'Un seul code promo par commande.',
    purchas_rule: "Si le prix de l'article est inférieur à la valeur du/des code(s) promo, la différence sera perdue.",
    profile_birthday: 'Profil - Date de naissance',
    profile_address: 'Profil - Adresse',
    profile_username: 'Profil - Nom',
    profile_picture: 'Profil - Photo',
    profile_contact: 'Profil - Informations de contact',
    membership_faq_title: 'ABONNEMENT',
    learn_more: 'Découvrir',
    profile_detail:
        "Complétez votre profil pour gagner jusqu'à 1000 EcoCredits : photo de profil (200), nom (100), informations de contact (300), adresse (200), et date de naissance (200).",
    exceeded_counts: "Echec de l'échange. Vous avez dépassé la limite d'échanges.",
    grab_title: 'Obtenez un bonus EcoCredits',
    grab_sub_title: 'Offres exclusives à durée limitée pour les membres EcoCredits. Cliquez pour en profiter maintenant !',
    grab_btn_text: 'Récupérer mon bonus',
    grab_success_title: 'Félicitations',
    grab_success_text1: 'Vous avez récupéré votre bonus !\n Utilisez le code lors du paiement pour obtenir votre réduction.',
    grab_success_text2: 'Consultez vos bonus dans l\'espace <code>"Mes récompenses"</code>.',
    'no-grab-content-note': "Plus d'offres à venir",
    copy_desc_2: 'Vous avez copié le code.',
    city_validatino_error: 'Ville non valide',
    product_text: 'Produit',
    shipping_address_text: 'Adresse de livraison',
    saved_address_text: 'Adresses enregistrées',
    use_new_address: 'Utiliser une nouvelle adresse',
    spend_now: 'Utiliser maintenant',
    stock_left: '{stock} restants',
    no_stock_tip: "Bientôt disponible...Restez à l'écoute !",
    order_text: 'Commande',
    campaign_time_limit_text: 'Période de remboursement valide: {startTime} - {endTime}.',
    event_action_text: 'Activité',
    warranty_minus_action_text: 'Garantie supprimée',
    question_correctly: 'Saurez-vous répondre à cette question',
    referral_correctly: 'Programme de parrainage',
    confirm_btn_text: 'Fermer',
    lucky_turntable_title: 'Tirage au sort',
    lucky_turntable_title2: 'Tirage au sort',
    join_lucky_with_points: 'Lorsque que vous effectuez un tour au Lucky Spin, cela vous coûte {points} EcoCredits.',
    join_lucky_with_points2: 'Il vous faut {points} EcoCredits pour jouer un tour.',
    join_lucky_desc: 'Tournez la roue et obtenez une belle récompense !',
    remaining_number: '<code></code> tours restants',
    remaining_number2: '<code></code> tentatives restantes',
    learn_lucky_rule: 'En savoir plus sur les règles',
    prize_coupon_title: 'Félicitations',
    prize_coupon_sub_title: 'Vous avez gagné un prix ! Utilisez ce code au moment du paiement pour bénéficier de votre réduction.',
    prize_coupon_action: 'Vous pouvez consulter vos prix dans <code>Mes récompenses</code>.',
    prize_coupon_button: 'Acheter maintenant',
    prize_points_title: 'Félicitations',
    prize_points_desc: 'Consultez les EcoCredits ajoutés récemment dans <code>Mon activité</code>.',
    limit_times_in_day: 'Vous pouvez tourner les roues <count></count> fois en <day></day> jours',
    limit_times_in_day2: 'Vous pouvez jouer <count></count> fois en <day></day> jours',
    limit_times_in_day_one: 'Vous pouvez tourner les roues <count></count> fois en <day></day> jour',
    limit_times_in_active: 'Pendant l’événement, vous pouvez tournez les roues jusqu’à <count></count> fois.',
    limit_times_in_active2: "Pendant les ventes flash, vous pouvez jouer jusqu'à <count></count> fois.",
    without_limit_times: 'Vous pouvez tourner les roues <count></count> fois à tout moment.',
    without_limit_times2: 'Vous pouvez jouer <count></count> fois à tout moment.',
    active_is_unstart: 'Cet événement va bientôt commencer.',
    active_is_ended: 'Cet événement est terminé. ',
    over_max_count: 'Vous avez dépassé le nombre de tours disponibles. ',
    notice_title: 'Avis',
    members_nav: 'Prix exclusifs',
    referral_nav: 'Parrainer un ami',
    points_cash: 'Remboursement en Points',
    Pending1: 'En Attente',
    rollback: 'Remboursé',
    product_hot_title: 'Les meilleures offres du moment',
    product_hot_desc: 'Achetez maintenant pour profiter de réductions imbattables et recevoir des cadeaux exclusifs !',
    product_refurbished_title: "Profitez d'offres exceptionnelles sur nos produits reconditionnés",
    product_refurbished_desc: '17/10/2024 09:00 (CEST) - 28/10/2024 08:59 (CEST) ',
    level_change_log: 'Activité',
    deadline: "Date d'expiration",
    history_refresh_member: 'Membre',
    history_refresh_plus_member: 'Membre PLUS',
    register: "S'inscrire",
    upgrade: 'Devenir membre PLUS',
    demotion: 'Annuler mon adhésion PLUS',
    relegation: 'Rester membre PLUS',
    wattayear_2024: 'Partager#WattAYear',
    site_account_profile_save_success: 'Enregistré',
    not_eligible: "Vous n'êtes pas éligible pour participer à cet événement.",

    // FAQ
    faq_tab_all: 'Toutes les questions',
};
